import { FormikField } from 'components/common/form/field/FormikField';
import { CollapsibleSection } from 'components/CollapsibleSection';
import { ChannelGroupSetting } from 'core/channelGroup/ChannelGroupSettings';
import { connect } from 'formik';
import i18next from 'i18n';
import { FC, useCallback } from 'react';
import styles from './agencyForm.module.scss';
import {
  adTypeOptionKey,
  getChannelGroupName,
  getVisibleAdTypes,
  normalizeAddonFeatures
} from './agencyAddonVisibility';
import { AddonSectionPlaceholder } from './AddonSectionPlaceholder';

const AgencyAdTypeAddonForm: FC<any> = (props) => {
  const { addonFeatures } = props.formik.values;
  const setValues = props.formik.setValues;

  // ad type 關閉時，連動把底下對應的 creative type 開關 reset 為 false
  const onAdTypeChange = useCallback(
    (adTypeSetting) => (open: boolean) => {
      setValues((values) => {
        const nextAddonFeatures = {
          ...values.addonFeatures,
          adTypes: {
            ...values.addonFeatures.adTypes,
            [`adType_${adTypeOptionKey(adTypeSetting)}`]: open
          }
        };
        return {
          ...values,
          addonFeatures: normalizeAddonFeatures(nextAddonFeatures)
        };
      });
    },
    [setValues]
  );

  const renderChannelGroupAdTypeSections = () => {
    return ChannelGroupSetting.activeValues()
      .map((channelGroup) => {
        // channel 關閉時不顯示；以 adTypeId（無則 name）去重
        const seen = new Set<string | number>();
        const adTypeSettings = getVisibleAdTypes(
          addonFeatures,
          channelGroup
        ).filter((adTypeSetting) => {
          const optionKey = adTypeOptionKey(adTypeSetting);
          if (seen.has(optionKey)) {
            return false;
          }
          seen.add(optionKey);
          return true;
        });
        if (adTypeSettings.length === 0) {
          return null;
        }
        return (
          <CollapsibleSection
            key={channelGroup.config.id}
            title={getChannelGroupName(channelGroup)}
            collapsible={true}
          >
            <div className={styles.fieldContent}>
              {adTypeSettings.map((adTypeSetting) => {
                const optionKey = adTypeOptionKey(adTypeSetting);
                const i18nKey = `adType.${adTypeSetting.name.toLowerCase()}`;
                const label = i18next.exists(i18nKey)
                  ? i18next.t(i18nKey)
                  : adTypeSetting.name;
                return (
                  <FormikField.Switch
                    key={optionKey}
                    label={label}
                    name={`addonFeatures.adTypes.adType_${optionKey}`}
                    onChange={onAdTypeChange(adTypeSetting)}
                  />
                );
              })}
            </div>
          </CollapsibleSection>
        );
      })
      .filter(Boolean);
  };

  const sections = renderChannelGroupAdTypeSections();

  if (sections.length === 0) {
    return (
      <div className={styles.agencyFrom}>
        <AddonSectionPlaceholder
          message={i18next.t('agency.placeholders.addon', {
            parent: i18next.t('agency.addonGroup.channel'),
            child: i18next.t('agencyDetail.labels.adTypeTab')
          })}
        />
      </div>
    );
  }

  return (
    <div className={styles.agencyFrom}>
      <fieldset>
        <legend>
          <span>{i18next.t('agencyDetail.labels.adTypeTab')}</span>
        </legend>
        <div className={styles.sectionsShadow}>{sections}</div>
      </fieldset>
    </div>
  );
};

export default connect(AgencyAdTypeAddonForm);
